module.exports = __webpack_public_path__ + "img/blue_061.b98e5442.png";